import React, { useEffect, useState } from 'react';
import { initialsFromName } from '../utils/format';

// If `photoUrl` is provided, render it as an <img> and fall back to the
// initials tile on load error. Matches the pattern the sidebar avatar
// uses in Layout.jsx.
export default function Avatar({ name, color, photoUrl, size = 44 }) {
  const initials = initialsFromName(name);
  const hasColor = !!color;
  const bg = hasColor ? color : 'var(--bg-tertiary)';

  // Reset the errored flag whenever the source URL changes.
  const [errored, setErrored] = useState(false);
  useEffect(() => {
    setErrored(false);
  }, [photoUrl]);

  const showImage = !!photoUrl && !errored;

  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: showImage ? 'var(--bg-tertiary)' : bg,
        // --text-inverted (dark) only reads correctly on a bright/saturated
        // avatarColor background. On the neutral --bg-tertiary fallback (no
        // avatarColor — the documented default per portfolio-api-contract.md)
        // it was landing at ~1.25:1 contrast in dark mode, effectively
        // invisible. Use --text-primary there instead, which stays correctly
        // paired with --bg-tertiary in both themes.
        color: hasColor ? 'var(--text-inverted)' : 'var(--text-primary)',
        display: 'grid',
        placeItems: 'center',
        fontWeight: 700,
        fontSize: Math.round(size * 0.4),
        letterSpacing: '0.02em',
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      {showImage ? (
        <img
          src={photoUrl}
          alt=""
          referrerPolicy="no-referrer"
          onError={() => setErrored(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      ) : (
        initials
      )}
    </div>
  );
}
